exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/Projekty/swaythegame/src/app/shared-components/modal-question/modal-question.component.scss
// module id = ../../../../../src/app/shared-components/modal-question/modal-question.component.scss
// module chunks = main